<div class="ticket-list-container">
  <h5 class="event-title">{{ title }}</h5>
  <!-- <p class="event-date">{{ eventDate }}</p> -->

  <div class="ticket-item" *ngFor="let ticket of tickets; let i = index">
    <div class="ticket-info">
      <h6>{{ ticket.title }}</h6>
      <p>{{ ticket.price | currency:'R' }}</p>
    </div>

    <div class="quantity-selector"
      *ngIf="ticket?.inventory?.isInventoryControlled && ticket?.inventory?.quantityOnHand > 0">
      <button (click)="decreaseQuantity(i)" [disabled]="ticket.quantity <= 0">-</button>
      <span>{{ ticket.quantity }}</span>
      <button (click)="increaseQuantity(i)" [disabled]="ticket.quantity >= ticket?.inventory?.quantityOnHand">
        +
      </button>
    </div>

    <p class="sold-out" *ngIf="ticket?.inventory?.isInventoryControlled && ticket?.inventory?.quantityOnHand <= 0">
      SOLD OUT
    </p>

  </div>
</div>